import { Link } from "react-router-dom";

export default function Canvas() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#faf8f6" }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "10px 16px", background: "#fff", borderBottom: "1px solid #ebe5df",
        fontFamily: "'DM Sans',sans-serif",
      }}>
        <Link to="/" style={{
          textDecoration: "none", color: "#b5836d", fontWeight: 600, fontSize: "14px",
        }}>← Volver</Link>
        <span style={{ fontSize: "14px", fontWeight: 700, color: "#2d2a26" }}>
          Modelo Canvas
        </span>
        <span style={{ width: "60px" }} />
      </div>
      <iframe
        src="/canvas.html"
        title="Business Model Canvas"
        style={{ flex: 1, width: "100%", border: "none" }}
      />
    </div>
  );
}
